import styled from "styled-components";

const GAP_BETWEEN_TITLE_AND_ICON = 8;
const ICON_SIZE = 22;

export const AccordionItemWrapper = styled.div`
    cursor: pointer;
`;

export const AccordionTitle = styled.div``;

export const AccordionTitleWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: ${GAP_BETWEEN_TITLE_AND_ICON}px;

    & > ${AccordionTitle} {
        flex: 1;
    }
`;

export const ItemContentOuterWrapper = styled.div<{ $maxHeight: string }>`
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
    padding-right: ${GAP_BETWEEN_TITLE_AND_ICON + ICON_SIZE}px;
    ${({ $maxHeight }) => $maxHeight && `max-height: ${$maxHeight};`}
`;

export const ItemContentInnerWrapper = styled.div`
    margin-top: 8px;
`;

export const AccordionContainer = styled.div`
    ${AccordionItemWrapper} + ${AccordionItemWrapper} {
        margin-top: 32px;
    }
`;
